import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EMPTY, Observable, of } from 'rxjs';
import { expand, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { uploadFiles } from 'src/app/shared/models/uploadFiles.model';
import { ELearningManagementService } from '../e-learning-management.service';
import * as tus from 'tus-js-client';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-modal-add-toppic',
  templateUrl: './modal-add-topic.component.html',
  styleUrls: ['./modal-add-topic.component.scss']
})
export class ModalAddTopicComponent implements OnInit {
  isLoading: boolean;
  modalData: any;
  videoForm: FormGroup;
  quizForm: FormGroup;
  assignmentForm: FormGroup;
  measureForm: FormGroup;

  assignmentDoc: File;
  originalNameVdo: string;
  vdoThumnal: string;
  optionImg = [];
  assignmentLink: string;
  fileUpload;
  pendingFiles: uploadFiles[] = [];
  allMeasure = [];

  vdoOldId: string;
  isEdit: boolean;
  type: string;
  hashKey: string;
  uploadVideoUri: string;
  isUploadSuccess: boolean = false;
  percentage: number;
  topicBody: { TOPIC_ID: string, TOPIC_TYPE: string };

  topicType = [{
    name: 'Video'
  }, {
    name: 'Quiz'
  }, {
    name: 'Assignment'
  }, {
    name: 'Measure'
  }]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddTopicComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private eLearningService: ELearningManagementService,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
    this.type = data.type;
    // console.log(data);
  }

  ngOnInit(): void {
    this.videoForm = this.fb.group({
      name: ['', Validators.required],
      vdo: ['', Validators.required],
      vdoThumnal: ['']
    })
    this.quizForm = this.fb.group({
      name: ['', Validators.required],
      timeQuizAgain: ['', Validators.required],
      passOfQuiz: ['', Validators.required],
      quizArray: this.fb.array([])
    })
    this.assignmentForm = this.fb.group({
      name: ['', Validators.required],
      assignmentDoc: ['', Validators.required],
      timeShow: ['', Validators.required]
    })
    this.measureForm = this.fb.group({
      // name: ['', Validators.required],
      measureId: ['', Validators.required]
    })

    this.eLearningService.getAllMeasure().subscribe(r => {
      // console.log(r);

      this.allMeasure = r.result;
    })

    if (this.modalData.isEdit) {
      this.topicBody = {
        TOPIC_ID: this.modalData.topicId,
        TOPIC_TYPE: this.modalData.type
      }
      this.eLearningService.getDetailByTopic(this.topicBody).subscribe(res => {
        // console.log(res);

        switch (this.modalData.type) {
          case 'Video': {
            this.originalNameVdo = res.result[0].ORIGINAL_NAME_VDO;
            this.vdoThumnal = res.result[0].VIDEO_THUMNAL_ORIGINAL;
            this.vdoOldId = res.result[0].TOPIC_ID;
            this.videoForm = this.fb.group({
              name: [res.result[0].TOPIC_NAME, Validators.required],
              vdo: '',
              vdoThumnal: ''
            })
            break;
          }

          case 'Assignment': {
            this.assignmentDoc = res.result[0].ASSIGNMENT_FILE_NAME;
            this.assignmentLink = res.result[0].ASSIGNMENT_FILE;
            this.assignmentForm = this.fb.group({
              name: [res.result[0].TOPIC_NAME, Validators.required],
              assignmentDoc: '',
              timeShow: [res.result[0].TIME_SHOW, Validators.required]
            })
            break;
          }

          case 'Quiz': {
            // console.log(res.result[0].VALUE);

            this.quizForm = this.fb.group({
              name: [res.result[0].TOPIC_NAME, Validators.required],
              timeQuizAgain: [res.result[0].TIME_QUIZ_AGAIN, Validators.required],
              passOfQuiz: [res.result[0].PASSOFQUIZ, Validators.required],
              quizArray: this.fb.array([])
            })
            res.result[0].VALUE.forEach((e, i) => {
              this.quizForm.get('quizArray')['controls'].push(this.fb.group({
                QUESTION: [e.QUESTION, Validators.required],
                OPTIONS: this.fb.array([]),
                ANSWER_NUMBER: [e.ANSWER_NUMBER, Validators.required],
              }))
              e.VALUE.forEach(c => {
                this.quizForm.get('quizArray')['controls'][i].get('OPTIONS').push(this.fb.group({
                  OPTION_NAME: [c.OPTION_NAME, Validators.required],
                  OPTION_IMAGENAME: [c.OPTION_PIC_ORIGINAL],
                  OPTION_NUMBER: [c.OPTION_NUMBER, Validators.required]
                }))
              })
              // // console.log(this.quizForm.value);
            });

            break;
          }

          case 'Measure': {
            // console.log(res.result[0]);
            this.measureForm = this.fb.group({
              measureId: [res.result[0].MEASURE_ID, Validators.required]
            })
            break;
          }
        }
      })
    }
  }

  log() {
    // console.log(this.measureForm.value);
  }

  selectVdoCover(e, videoForm) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.vdoThumnal = e.target.files[0].name;
        const file = (e.target as HTMLInputElement).files[0];

        videoForm.patchValue({
          vdoThumnal: file
        });
        videoForm.get('vdoThumnal').updateValueAndValidity();
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  selectAssignment(e, assignmentForm) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
      if (e.target.files && e.target.files[0]) {
        this.assignmentDoc = e.target.files[0].name;
        const file = (e.target as HTMLInputElement).files[0];

        assignmentForm.patchValue({
          assignmentDoc: file
        });
        assignmentForm.get('assignmentDoc').updateValueAndValidity();
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ CSV, XLSX, PDF, DOC, DOCX เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  setType(t) {
    this.type = t.target.value;
    this.modalData.isEdit = false;

    this.videoForm.reset();
    this.quizForm.reset();
    this.assignmentForm.reset();
    this.measureForm.reset();

    this.optionImg = [];
    this.assignmentDoc = null;
    this.originalNameVdo = null;
    this.vdoThumnal = null;
    this.vdoOldId = null;
  }

  addTopic(form, isEdit) {
    // // console.log(form);
    // // console.log(this.modalData);
    // // console.log(this.type);

    let haveService: boolean;
    let service;
    let body;
    let subService;
    this.isLoading = true;

    switch (this.type) {
      case 'Video': {
        if (!isEdit) {
          if (this.modalData.topicId) {
            // กรณีกดแก้ไข แล้วเปลี่ยนหัวข้อ จะต้องลบและสร้างใหม่

            service = this.eLearningService.createVideoLesson(form.vdo).pipe(
              map(response => {
                const videoFile = new uploadFiles(form.vdo, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    this.isLoading = false;
                    // console.log('Videos uploaded successfully');

                    body = {
                      TYPE_CREATE: 'Video',
                      COURSE_ID: this.modalData.courseId,
                      LESSON_ID: this.modalData.lessonId,
                      VIDEO_COURSE_ID: this.uploadVideoUri,
                      VIDEO_NAME: form.name,
                      ORIGINAL_NAME_VDO: form.vdo.name,
                      LINE: this.modalData.line,
                      VIDEO_THUMNAL: form.vdoThumnal,
                      HASH_KEY: this.hashKey
                    }
                    // console.log(body);

                    subService = this.eLearningService.delTopicById(this.topicBody).pipe(
                      switchMap(() => {
                        return this.eLearningService.createVideoCourse(body);
                      })
                    ).subscribe(res => {
                      if (res.success) {
                        // console.log(res);
                        this.isLoading = false;
                        const response = {
                          status: true,
                        }
                        this.dialogRef.close(response);
                      }
                      subService.unsubscribe();
                    }, (error) => {
                      // console.log(error);
                    })
                  }
                }).start();
              }),
            ).subscribe();
            break;
          } else {
            service = this.eLearningService.createVideoLesson(form.vdo).pipe(
              map(response => {
                const videoFile = new uploadFiles(form.vdo, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    this.isLoading = false;
                    // console.log('Videos uploaded successfully');

                    body = {
                      TYPE_CREATE: 'Video',
                      COURSE_ID: this.modalData.courseId,
                      LESSON_ID: this.modalData.lessonId,
                      VIDEO_COURSE_ID: this.uploadVideoUri,
                      VIDEO_NAME: form.name,
                      ORIGINAL_NAME_VDO: form.vdo.name,
                      LINE: this.modalData.line,
                      VIDEO_THUMNAL: form.vdoThumnal,
                      HASH_KEY: this.hashKey
                    }
                    // console.log(body);

                    subService = this.eLearningService.createVideoCourse(body).subscribe(res => {
                      // console.log(res);
                      if (res.success) {
                        this.isLoading = false;
                        const response = {
                          status: true,
                        }
                        this.dialogRef.close(response);
                      }
                      subService.unsubscribe();
                    }, (error) => {
                      // console.log(error);
                    });
                  }
                }).start();
              }),
            ).subscribe();
            break;
          }
        } else {
          if (form.vdo) {
            service = this.eLearningService.createVideoLesson(form.vdo).pipe(
              map(response => {
                const videoFile = new uploadFiles(form.vdo, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    this.isLoading = false;
                    // console.log('Videos uploaded successfully');

                    body = {
                      VIDEO_COURSE_ID_NEW: this.uploadVideoUri,
                      VIDEO_COURSE_ID_OLD: this.vdoOldId,
                      VIDEO_NAME: form.name,
                      ORIGINAL_NAME_VDO: form.vdo.name,
                      VIDEO_THUMNAL: form.vdoThumnal,
                      HASH_KEY: this.hashKey
                    }
                    // console.log(body);

                    subService = this.eLearningService.editVideoById(body).subscribe(res => {
                      if (res.success) {
                        // // console.log(res);
                        this.isLoading = false;
                        const response = {
                          status: true,
                        }
                        this.dialogRef.close(response);
                      }
                      subService.unsubscribe();
                    }, (error) => {
                      // console.log(error);
                    });
                  }
                }).start();
              }),
            ).subscribe();
            break;
          } else {
            body = {
              VIDEO_COURSE_ID_NEW: this.uploadVideoUri ? this.uploadVideoUri : '',
              VIDEO_COURSE_ID_OLD: this.vdoOldId,
              VIDEO_NAME: form.name,
              ORIGINAL_NAME_VDO: this.originalNameVdo,
              VIDEO_THUMNAL: form.vdoThumnal ? form.vdoThumnal : this.vdoThumnal,
              HASH_KEY: ''
            }

            subService = this.eLearningService.editVideoById(body).subscribe(res => {
              if (res.success) {
                // // console.log(res);
                this.isLoading = false;
                const response = {
                  status: true,
                }
                this.dialogRef.close(response);
              }
              subService.unsubscribe();
            }, (error) => {
              // console.log(error);
            });
            break;
          }
        }
      }


      case 'Quiz': {
        if (!isEdit) {
          if (form.quizArray?.length > 0) {
            // เช็คคะแนนผ่านเกณฑ์ ต้องมากกว่าคำถาม หรือ เท่ากัน
            if (form.passOfQuiz <= form.quizArray?.length) {
              if (this.modalData.topicId) {
                // กรณีกดแก้ไข แล้วเปลี่ยนหัวข้อ จะต้องลบและสร้างใหม่
                body = {
                  TYPE_CREATE: 'Quiz',
                  QUIZ_NAME: form.name,
                  COURSE_ID: this.modalData.courseId,
                  LESSON_ID: this.modalData.lessonId,
                  TIME_QUIZ_AGAIN: form.timeQuizAgain,
                  PASSOFQUIZ: form.passOfQuiz,
                  OPTION_IMAGE: this.optionImg,
                  VALUE: form.quizArray,
                  LINE: this.modalData.line
                }
                service = this.eLearningService.delTopicById(this.topicBody).pipe(
                  switchMap(() => {
                    return this.eLearningService.createQuiz(body);
                  })
                )
                haveService = true;
                break;
              } else {
                // กรณีสร้างแบบ quiz
                let names = this.optionImg.map(o => o.name);
                this.optionImg = this.optionImg.filter(({ name }, index) => !names.includes(name, index + 1))
                // // console.log(this.optionImg);

                if (form.quizArray.length > 0) {
                  body = {
                    TYPE_CREATE: 'Quiz',
                    QUIZ_NAME: form.name,
                    COURSE_ID: this.modalData.courseId,
                    LESSON_ID: this.modalData.lessonId,
                    TIME_QUIZ_AGAIN: form.timeQuizAgain,
                    PASSOFQUIZ: form.passOfQuiz,
                    OPTION_IMAGE: this.optionImg,
                    VALUE: form.quizArray,
                    LINE: this.modalData.line
                  }
                  service = this.eLearningService.createQuiz(body);
                  haveService = true;
                }
                break;
              }
            } else {
              alert('คะแนนผ่านเกณฑ์ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง')
              this.isLoading = false;
              haveService = false;
              break;
            }
          } else if (form.quizArray.length === 0) {
            alert('กรุณาเพิ่มคำถาม');
            haveService = false;
            this.isLoading = false;
            break;
          }
        } else {
          let formArr = [];
          let names = this.optionImg.map(o => o.name);
          this.optionImg = this.optionImg.filter(({ name }, index) => !names.includes(name, index + 1))
          // // console.log(this.optionImg);
          // // console.log(form);
          // // console.log(this.quizForm.value);

          for (let i = 0; i < form.length; i++) {
            formArr.push(form[i].value);
          }

          if (formArr.length > 0) {
            if (this.quizForm.value.passOfQuiz <= formArr.length) {
              // เช็คคะแนนผ่านเกณฑ์ ต้องมากกว่าคำถาม หรือ เท่ากัน

              body = {
                QUIZ_ID: this.modalData.topicId,
                QUIZ_NAME: this.quizForm.value.name,
                TIME_QUIZ_AGAIN: this.quizForm.value.timeQuizAgain,
                PASSOFQUIZ: this.quizForm.value.passOfQuiz,
                OPTION_IMAGE: this.optionImg,
                VALUE: formArr
              }
              service = this.eLearningService.editQuizCourseById(body);
              haveService = true;
              break;
            } else {
              alert('คะแนนผ่านเกณฑ์ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง')
              this.isLoading = false;
              haveService = false;
              break;
            }
          } else if (formArr.length === 0) {
            alert('กรุณาเพิ่มคำถาม');
            haveService = false;
            this.isLoading = false;
            break;
          }
          break;
        }


        // if (form.quizArray?.length > 0) {
        //   // เช็คคะแนนผ่านเกณฑ์ ต้องมากกว่าคำถาม หรือ เท่ากัน
        //   if (form.passOfQuiz <= form.quizArray?.length) {
        //     if (!isEdit) {
        //       if (this.modalData.topicId) {
        //         // กรณีกดแก้ไข แล้วเปลี่ยนหัวข้อ จะต้องลบและสร้างใหม่
        //         body = {
        //           TYPE_CREATE: 'Quiz',
        //           QUIZ_NAME: form.name,
        //           COURSE_ID: this.modalData.courseId,
        //           LESSON_ID: this.modalData.lessonId,
        //           TIME_QUIZ_AGAIN: form.timeQuizAgain,
        //           PASSOFQUIZ: form.passOfQuiz,
        //           OPTION_IMAGE: this.optionImg,
        //           VALUE: form.quizArray,
        //           LINE: this.modalData.line
        //         }
        //         service = this.eLearningService.delTopicById(this.topicBody).pipe(
        //           switchMap(() => {
        //             return this.eLearningService.createQuiz(body);
        //           })
        //         )
        //         haveService = true;
        //         break;
        //       } else {
        //         // กรณีสร้างแบบ quiz
        //         let names = this.optionImg.map(o => o.name);
        //         this.optionImg = this.optionImg.filter(({ name }, index) => !names.includes(name, index + 1))
        //         // // console.log(this.optionImg);

        //         if (form.quizArray.length > 0) {
        //           body = {
        //             TYPE_CREATE: 'Quiz',
        //             QUIZ_NAME: form.name,
        //             COURSE_ID: this.modalData.courseId,
        //             LESSON_ID: this.modalData.lessonId,
        //             TIME_QUIZ_AGAIN: form.timeQuizAgain,
        //             PASSOFQUIZ: form.passOfQuiz,
        //             OPTION_IMAGE: this.optionImg,
        //             VALUE: form.quizArray,
        //             LINE: this.modalData.line
        //           }
        //           service = this.eLearningService.createQuiz(body);
        //           haveService = true;
        //         }
        //         break;
        //       }
        //     } else {
        //       let formArr = [];
        //       let names = this.optionImg.map(o => o.name);
        //       this.optionImg = this.optionImg.filter(({ name }, index) => !names.includes(name, index + 1))
        //       // // console.log(this.optionImg);
        //       // // console.log(form);
        //       // // console.log(this.quizForm.value);

        //       for (let i = 0; i < form.length; i++) {
        //         formArr.push(form[i].value);
        //       }

        //       body = {
        //         QUIZ_ID: this.modalData.topicId,
        //         QUIZ_NAME: this.quizForm.value.name,
        //         TIME_QUIZ_AGAIN: this.quizForm.value.timeQuizAgain,
        //         PASSOFQUIZ: this.quizForm.value.passOfQuiz,
        //         OPTION_IMAGE: this.optionImg,
        //         VALUE: formArr
        //       }
        //       service = this.eLearningService.editQuizCourseById(body);
        //       haveService = true;
        //       break;
        //     }
        //   } else {
        //     alert('คะแนนผ่านเกณฑ์ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง')
        //     this.isLoading = false;
        //     haveService = false;
        //     break;
        //   }
        // } else if (form.quizArray.length === 0) {
        //   alert('กรุณาเพิ่มคำถาม');
        //   haveService = false;
        //   this.isLoading = false;
        //   break;
        // }
      }


      case 'Assignment': {
        if (!isEdit) {
          if (this.modalData.topicId) {
            // กรณีกดแก้ไข แล้วเปลี่ยนหัวข้อ จะต้องลบและสร้างใหม่
            body = {
              TYPE_CREATE: 'Assignment',
              COURSE_ID: this.modalData.courseId,
              LESSON_ID: this.modalData.lessonId,
              ASSIGNMENT_NAME: form.name,
              TIME_SHOW: form.timeShow,
              ASSIGNMENT_DOC: form.assignmentDoc,
              LINE: this.modalData.line
            }
            service = this.eLearningService.delTopicById(this.topicBody).pipe(
              switchMap(() => {
                return this.eLearningService.createAssignment(body);
              })
            )
            haveService = true;
            break;
          } else {
            // กรณีสร้างแบบฝึกหัด
            body = {
              TYPE_CREATE: 'Assignment',
              COURSE_ID: this.modalData.courseId,
              LESSON_ID: this.modalData.lessonId,
              ASSIGNMENT_NAME: form.name,
              TIME_SHOW: form.timeShow,
              ASSIGNMENT_DOC: form.assignmentDoc,
              LINE: this.modalData.line
            }
            service = this.eLearningService.createAssignment(body);
            haveService = true;
            break;
          }
        } else {
          body = {
            TYPE_CREATE: 'Assignment',
            COURSE_ID: this.modalData.courseId,
            LESSON_ID: this.modalData.lessonId,
            TOPIC_ID: this.modalData.topicId,
            ASSIGNMENT_NAME: form.name,
            TIME_SHOW: form.timeShow,
            ASSIGNMENT_DOC: form.assignmentDoc
          }
          service = this.eLearningService.editAssignmentCourseById(body);
          haveService = true;
          break;
        }
      }


      case 'Measure': {
        if (!isEdit) {
          if (this.modalData.topicId) {
            body = {
              TYPE_CREATE: 'Measure',
              COURSE_ID: this.modalData.courseId,
              LESSON_ID: this.modalData.lessonId,
              MEASURE_ID: form.measureId,
              LINE: JSON.stringify(this.modalData.line)
            }

            service = this.eLearningService.delTopicById(this.topicBody).pipe(
              switchMap(() => {
                return this.eLearningService.createMeasureByCourse(body);
              })
            )
            haveService = true;
            break;
          } else {
            body = {
              TYPE_CREATE: 'Measure',
              COURSE_ID: this.modalData.courseId,
              LESSON_ID: this.modalData.lessonId,
              MEASURE_ID: form.measureId,
              LINE: JSON.stringify(this.modalData.line)
            }

            service = this.eLearningService.createMeasureByCourse(body);
            haveService = true;
            break;
          }
        } else {
          body = {
            ID: this.modalData.topicId,
            MEASURE_ID: form.measureId,
          }

          service = this.eLearningService.editMeasureByCourse(body);
          haveService = true;
          break;
        }
      }

      default:
        break;
    }

    if (haveService) {
      service.subscribe(res => {
        if (res.success) {
          this.isLoading = false;
          const response = {
            status: true,
          }
          this.dialogRef.close(response);
        } else {
          // console.log(res);
        }
      });
    }
  }

  delete(id, type) {
    const body = {
      TOPIC_ID: id,
      TOPIC_TYPE: type
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirmDelete';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ยืนยันการลบ',
      actionBtnText: 'ลบ',
      cancleBtnText: 'ยกเลิก',
      isDelete: true,
      description: `คุณต้องการลบหัวข้อนี้ใช่หรือไม่?`
    }

    const modalDelete = this.matDialog.open(ModalComponent, dialogConfig);
    modalDelete.afterClosed().pipe(
      switchMap(isDelete => {
        if (isDelete) {
          return this.eLearningService.delTopicById(body).pipe(
            map(() => {
              this.dialogRef.close({ status: true });
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()
  }

  addPic(e, quizForm) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        const file = (e.target as HTMLInputElement).files[0];

        quizForm.patchValue({
          OPTION_IMAGENAME: file.name
        });
        quizForm.get('OPTION_IMAGENAME').updateValueAndValidity();
        this.optionImg.push(file);
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  selectVDO(e, videoForm) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    if (fileType === 'mp4') {
      if (e.target.files && e.target.files[0]) {
        this.originalNameVdo = e.target.files[0].name;
        const file = (e.target as HTMLInputElement).files[0];
        this.fileUpload = e.target.files;

        videoForm.patchValue({
          vdo: file
        });
        videoForm.get('vdo').updateValueAndValidity();
        // this.start(e.target.files);
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ MP4 เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  addGroup(isEdit: boolean, i) {
    if (isEdit) {
      (<FormArray>this.quizForm.get('quizArray')).push(this.fb.group({
        QUESTION: ['', Validators.required],
        OPTIONS: this.fb.array([]),
        ANSWER_NUMBER: ['', Validators.required],
      }));
      this.updateQuizArrayForm();

    } else {
      (<FormArray>this.quizForm.get('quizArray')).push(this.fb.group({
        QUESTION: ['', Validators.required],
        OPTIONS: ['', this.fb.array([])],
        ANSWER_NUMBER: ['', Validators.required],
      }));
    }
    this.addChoice(isEdit, i);
  }

  removeGroup(isEdit: boolean, index) {
    (<FormArray>this.quizForm.get('quizArray')).removeAt(index);
    this.updateQuizArrayForm();
  }

  addChoice(isEdit: boolean, i) {
    (<FormArray>this.quizForm.get('quizArray')['controls'][i].get('OPTIONS')).push(this.fb.group({
      OPTION_NAME: ['', Validators.required],
      OPTION_IMAGENAME: '',
      OPTION_NUMBER: ['', Validators.required]
    }))
    this.updateQuizArrayForm();
  }

  removeChoice(isEdit: boolean, i, j) {
    (<FormArray>this.quizForm.get('quizArray')['controls'][i].get('OPTIONS')).removeAt(j);
    (<FormArray>this.quizForm.get('quizArray')['controls'][i].get('ANSWER_NUMBER').setValue(''));
    this.updateQuizArrayForm();
  }

  updateQuizArrayForm() {
    this.quizForm.get('quizArray').updateValueAndValidity();
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }
}
